import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { DashboardRedirectGuard } from 'app/core/auth/guards/dashboard-redirect.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to role-based dashboard
    {path: '', pathMatch : 'full', redirectTo: 'redirect-dashboard'},

    // Redirect signed-in user to role-based dashboard
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'redirect-dashboard'},

    // Dynamic dashboard redirect based on user role
    {
        path: 'redirect-dashboard',
        canActivate: [AuthGuard, DashboardRedirectGuard],
        component: LayoutComponent, // Required but won't be shown
    },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes')},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes')}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
            {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes')}
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes')},
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            // Dashboard for SUPER_ADMIN (global view)
            {path: 'dashboard', loadChildren: () => import('app/modules/admin/dashboard/dashboard.routes')},

            // Dashboard for Store Admins (single store view)
            {path: 'store-dashboard', loadChildren: () => import('app/modules/admin/store-dashboard/store-dashboard.routes')},

            // Catalogs
            {path: 'catalogs', loadChildren: () => import('app/modules/admin/catalogs/catalogs.routes')},

            // Operations
            {path: 'operations', loadChildren: () => import('app/modules/admin/operations/operations.routes')},

            // Inventory
            {path: 'inventory', loadChildren: () => import('app/modules/admin/inventory/inventory.routes')},

            // Incidents
            {path: 'incidents', loadChildren: () => import('app/modules/admin/incidents/incidents.routes')},

            // Settings
            {path: 'settings', loadChildren: () => import('app/modules/admin/settings/settings.routes')},

            // Legacy example (can be removed)
            {path: 'example', loadChildren: () => import('app/modules/admin/example/example.routes')},
        ]
    }
];
